import axios from 'axios';

export const download = (id) => axios.get(`/termo-posse/${id}/download`, {
  responseType: 'arraybuffer',
});
